var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactiveClients(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16675 24.8017V19.9726C6.16675 18.7886 7.12571 17.8296 8.30968 17.8296H18.3097C19.4937 17.8296 20.4526 18.7886 20.4526 19.9726V24.8017M19.0244 8C20.7783 8 22.1991 9.42184 22.1991 11.1748C22.1991 12.9277 20.7773 14.3495 19.0244 14.3495M24.0238 17.8307C25.2078 17.8307 26.1667 18.7897 26.1667 19.9736V24.8027M16.4839 11.1748C16.4839 12.9281 15.0625 14.3495 13.3091 14.3495C11.5558 14.3495 10.1344 12.9281 10.1344 11.1748C10.1344 9.42139 11.5558 8 13.3091 8C15.0625 8 16.4839 9.42139 16.4839 11.1748Z",
    stroke: "#71717A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveClients);
export default __webpack_public_path__ + "static/media/inactiveClients.cc421d7543163884dfa553f3fcd45cd7.svg";
export { ForwardRef as ReactComponent };